module.exports = __webpack_public_path__ + "static/img/4.50e0920.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/eng/4.png
// module id = lbcR
// module chunks = 0